import { createSelector } from 'reselect';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'matchups';
export const selectMatchupsState = state => state[STORE_KEY];

export const selectMatchupsForDropdown = createSelector(
  selectMatchupsState,
  matchups => {
    /* PLACEHOLDER until all matches are returned from API */
    // const matchupList = [{
    //   key: 'all', value: 'all', text: 'All Matchups',
    // }];
    const matchupList = [];
    return matchupList.concat(
      matchups.matchups.map(matchup => ({
        key: matchup.game_id,
        value: Number(matchup.game_id),
        text: `${matchup.away_team_abbr} at ${matchup.home_team_abbr}`,
      })),
    );
  },
);
// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  matchups: [],
};

const matchupsReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default matchupsReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_MATCHUPS_REQUEST = `${STORE_KEY}/LOAD_MATCHUPS_REQUEST`;
export const LOAD_MATCHUPS_ERROR = `${STORE_KEY}/LOAD_MATCHUPS_ERROR`;
export const LOAD_MATCHUPS_SUCCESS = `${STORE_KEY}/LOAD_MATCHUPS_SUCCESS`;

export const loadMatchupsRequest = (year, week) => ({
  type: LOAD_MATCHUPS_REQUEST,
  payload: {
    year,
    week,
  },
});
export const loadMatchupsError = error => ({
  type: LOAD_MATCHUPS_ERROR,
  payload: {
    error,
  },
});
export const loadMatchupsSuccess = ({ matchups }) => ({
  type: LOAD_MATCHUPS_SUCCESS,
  payload: {
    matchups,
  },
});
actions[LOAD_MATCHUPS_REQUEST] = (state, { payload }) => ({ ...state,
  year: payload.year,
  week: payload.week,
});
actions[LOAD_MATCHUPS_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  error: payload.error,
});
actions[LOAD_MATCHUPS_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  matchups: payload.matchups,
});

export const loadMatchups = (year, week) => async (dispatch, getState, { api }) => {
  const state = selectMatchupsState(getState());
  dispatch(loadMatchupsRequest(year, week));

  if ((year === state.year) && (week === state.week) && (state.matchups.length)) {
    return Promise.resolve();
  }

  try {
    const matchups = await api.lookups.getMatchups({ year, week });
    return dispatch(loadMatchupsSuccess(matchups));
  } catch (error) {
    return dispatch(loadMatchupsError(error));
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/matchups.js